// src/notifications/notistackNotificationProvider.ts
import type { NotificationProvider } from "@refinedev/core";

export const notistackNotificationProvider: NotificationProvider = {
  open: ({ message, type, description }) => {
    const enqueue = (window as any).__enqueueSnackbar as
      | ((msg: string, opts?: any) => void)
      | undefined;

    // if bridge not ready, don't crash
    if (typeof enqueue !== "function") {
      console.warn("[notify] notistack not ready:", message, description);
      return;
    }

    const text = description ? `${message}\n${description}` : message;

    enqueue(text, {
      variant:
        type === "error"
          ? "error"
          : type === "success"
            ? "success"
            : type === "warning"
              ? "warning"
              : "info",
    });
  },
  close: (key) => {
    const close = (window as any).__closeSnackbar as
      | ((key?: string | number) => void)
      | undefined;
    if (typeof close === "function") {
      close(key);
    }
  },
};
